// dependencies imports ⇒
import React, { useEffect, useState } from "react";
// assets and scss imports ⇒
import "./consentGrantedViewDocuments.scss";
import leftArrow from "../../../../assets/right_arrow.svg";
import forwordArrow from "../../../../assets/arrow-down.png";
import moment from "moment/moment";
// project file imports(UI components) ⇒
import ComponentSpecificLoader from "../../../UI Component/Loader/ComponentSpecificLoader";
// const file imports(helper methods, etc) ⇒
import { c2cGetApiHandler } from "../../../../Util/c2cApiHandler";
import { GET_GRANTED_DOCUMENTS } from "../AbhahealthRecordApiHandler/apiConstants";

function ConsentGrantedViewDocuments(props) {
  // const declarations ⇒
  const { appointmentDetails, consentRequestId, handleSelectPage } = props;

  const [patientHealthRecords, setPatientHealthRecord] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [loader, setLoader] = useState(false);
  // let or var declarations ⇒
  // life cycle methods ⇒

  useEffect(() => {
    getConsentGrantedDocuments();
  }, []);

  // API Calls ⇒

  const getConsentGrantedDocuments = () => {
    let params = {
      consentRequestId: consentRequestId,
    };
    setLoader(true);
    let resData = c2cGetApiHandler(GET_GRANTED_DOCUMENTS(params));
    resData.then(([res, err]) => {
      if (!err && res?.data?.statusCode === 200) {
        setLoader(false);
        let arr = [];
        res.data.data.forEach((ele) => {
          let dateInd = arr.findIndex(
            (item) =>
              item.recordedDate === moment(ele.timestamp).format("DD MMM YYYY")
          );
          let ind = ele.entry.findIndex(
            (item) => item?.resource?.resourceType === "Composition"
          );
          let docInd = ele.entry.findIndex(
            (item) => item?.resource?.resourceType === "DocumentReference"
          );
          let clinicName = "",
            author = "",
            status = "",
            linkTitle = "",
            docTitle = "",
            attachments = [];
          if (ind !== -1) {
            if (
              ele.entry[ind]?.resource?.attester[0]?.party?.type ===
              "Organization"
            ) {
              clinicName =
                ele.entry[ind]?.resource?.attester[0]?.party?.display;
            }
            if (ele.entry[ind]?.resource?.author[0]?.type === "Practitioner") {
              author = ele.entry[ind]?.resource?.author[0]?.display;
            }
            status = ele.entry[ind]?.resource?.status ?? "";
            linkTitle = ele.entry[ind]?.resource?.section[0]?.title;
            docTitle = ele.entry[ind]?.resource?.title ?? "";
          }
          if (docInd !== -1) {
            attachments = [];
            ele.entry[docInd].resource.content.forEach((link) => {
              let typeInd = link.attachment.contentType.lastIndexOf("/");

              attachments.push({
                ...link.attachment,
                fileType: link.attachment.contentType.substring(typeInd + 1),
              });
            });
          }
          if (dateInd === -1) {
            arr.push({
              recordedDate: moment(ele.timestamp).format("DD MMM YYYY"),
              clinics: [
                {
                  clinicName: clinicName,
                  documents: [
                    {
                      docTitle: docTitle,
                      date: moment(ele.timestamp).format("DD/MM/YYYY HH:mm"),
                      author: author,
                      status: status,
                      linkTitle: linkTitle,
                      attachments: attachments,
                    },
                  ],
                },
              ],
            });
          } else {
            let clinicInd = arr[dateInd].clinics.findIndex(
              (item) => item.clinicName === clinicName
            );
            if (clinicInd !== -1) {
              arr[dateInd].clinics[clinicInd].documents.push({
                docTitle: docTitle,
                date: moment(ele.timestamp).format("DD/MM/YYYY HH:mm"),
                author: author,
                status: status,
                linkTitle: linkTitle,
                attachments: attachments,
              });
            } else {
              arr[dateInd].clinics.push({
                clinicName: clinicName,
                documents: [
                  {
                    docTitle: docTitle,
                    date: moment(ele.timestamp).format("DD/MM/YYYY HH:mm"),
                    author: author,
                    status: status,
                    linkTitle: linkTitle,
                    attachments: attachments,
                  },
                ],
              });
            }
          }
        });
        arr.forEach((ele) => {
          ele.clinics.forEach((item) => {
            item.documents.sort((a, b) => a.date.localeCompare(b.date));
          });
          ele.clinics.sort((a, b) => a.clinicName.localeCompare(b.clinicName));
        });
        arr.sort((a, b) => a.recordedDate.localeCompare(b.recordedDate));
        console.log(arr);
        setPatientHealthRecord([...arr]);
      } else {
        setPatientHealthRecord([]);
        setLoader(false);
      }
    });
  };

  // Helper methods ⇒
  // Actions ⇒

  const handleDateChange = (val) => {
    setActiveIndex(val);
  };

  // create UI ⇒

  const consentGrantedViewDocumentListUI = (doc) => {
    return (
      <div className="cgvl-list-wrapper">
        <div className="cgvl-list-heading">DOCUMENT: {doc.docTitle}</div>
        <div className="cgvl-date-author-status-wrapper">
          <div className="cgvl-date-status-author">
            <div className="date-status-author-title">Date: </div>
            <div className="date-status-author-value">{doc.date}</div>
          </div>
          <div className="cgvl-date-status-author">
            <div className="date-status-author-title">Authors: -</div>
            <div className="date-status-author-value">{doc.author}</div>
          </div>
          <div className="cgvl-date-status-author">
            <div className="date-status-author-title">Status: </div>
            <div
              className="date-status-author-value"
              style={{ textTransform: "uppercase" }}
            >
              {doc.status}
            </div>
          </div>
        </div>
        <div className="cgvl-list-footer">
          <div className="cgvl-list-footer-title">
            {doc.linkTitle} links and attachments :
          </div>
          <div className="cgvl-document-link-container">
            {doc.attachments.map((link, linkInd) => (
              <div key={linkInd} style={{ marginRight: "5px" }}>
                <a
                  className="cgvl-document-link"
                  href={`data:${link?.contentType};base64,${link?.data}`}
                  download={`${link?.title}.${link?.fileType}`}
                >
                  {link?.title}
                </a>
                <span style={{ fontSize: "16px" }}>
                  {linkInd !== doc.attachments?.length - 1 ? ", " : ""}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const consentGrantedViewDocumentsUi = () => {
    return (
      <div className="consent-granted-view-list-container">
        <div className="cgvl-back-btn" onClick={() => handleSelectPage(3)}>
          <img className="cgvl-back-btn-arrow" src={leftArrow} alt="#" />
          Back
        </div>
        <div className="cgvl-content-container">
          <div className="cgvl-name-record-date-wrapper">
            <div className="crvl-name-wrapper">
              Name: {appointmentDetails?.patient_name}
            </div>
            <div className="crvl-date-wrapper">
              <div className="crvl-date-wrapper-text">
                {" "}
                View By Recorded Date{" "}
              </div>
              <img
                className="cgvd-left-arrow"
                src={forwordArrow}
                onClick={() =>
                  patientHealthRecords[activeIndex - 1]
                    ? handleDateChange(activeIndex - 1)
                    : ""
                }
                style={{
                  cursor: patientHealthRecords[activeIndex - 1]
                    ? ""
                    : "not-allowed",
                }}
              />
              <div className="crvl-date-wrapper-value">
                {patientHealthRecords[activeIndex]?.recordedDate}
              </div>
              <img
                className="cgvd-right-arrow"
                src={forwordArrow}
                onClick={() =>
                  patientHealthRecords[activeIndex + 1]
                    ? handleDateChange(activeIndex + 1)
                    : ""
                }
                style={{
                  cursor: patientHealthRecords[activeIndex + 1]
                    ? ""
                    : "not-allowed",
                }}
              />
            </div>
          </div>
          <div className="cgvd-documents-container">
            {patientHealthRecords?.length !== 0
              ? patientHealthRecords[activeIndex].clinics.map((item, ind) => (
                  <div key={ind}>
                    <div className="cgvl-hospital-name">{item.clinicName}</div>
                    {item.documents.map((doc, index) => (
                      <div key={index} className="cgvl-list-container">
                        {consentGrantedViewDocumentListUI(doc)}
                      </div>
                    ))}
                  </div>
                ))
              : !loader && (
                  <div className="no-document-found">
                    DOCUMENTS DO NOT EXIST
                  </div>
                )}
          </div>
        </div>
      </div>
    );
  };

  //

  return (
    <div className="consent-granted-view-container">
      {loader && <ComponentSpecificLoader />}
      {consentGrantedViewDocumentsUi()}
    </div>
  );
}

export default ConsentGrantedViewDocuments;
